module.exports = __webpack_public_path__ + "img/es.a9d55358.svg";